var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    {
      staticClass: "mql-textradio",
      class: [
        _vm.radioSize ? "mql-textradio--" + _vm.radioSize : "",
        { "is-disabled": _vm.isDisabled },
        { "is-focus": _vm.focus },
        { "is-defined": _vm.defined },
        { "is-checked": !_vm.defined && _vm.model == _vm.label }
      ],
      attrs: {
        role: "radio",
        "aria-checked": _vm.model == _vm.label,
        "aria-disabled": _vm.isDisabled,
        tabindex: _vm.tabIndex
      },
      on: {
        keydown: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])
          ) {
            return null
          }
          $event.stopPropagation()
          $event.preventDefault()
          _vm.model = _vm.isDisabled ? _vm.model : _vm.label
        }
      }
    },
    [
      _c(
        "span",
        {
          staticClass: "mql-textradio__input",
          class: {
            "is-disabled": _vm.isDisabled,
            "is-checked": _vm.model == _vm.label
          }
        },
        [
          !_vm.defined
            ? [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.model,
                      expression: "model"
                    }
                  ],
                  staticClass: "mql-textradio__original",
                  attrs: {
                    type: "radio",
                    "aria-hidden": "true",
                    name: _vm.name,
                    disabled: _vm.isDisabled,
                    tabindex: ""
                  },
                  domProps: {
                    value: _vm.label,
                    checked: _vm._q(_vm.model, _vm.label)
                  },
                  on: {
                    focus: function($event) {
                      _vm.focus = true
                    },
                    blur: function($event) {
                      _vm.focus = false
                    },
                    change: [
                      function($event) {
                        _vm.model = _vm.label
                      },
                      _vm.handleChange
                    ]
                  }
                })
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "mql-textradio__label",
          on: {
            keydown: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _vm._t("default", null, { data: _vm.value }),
          _vm._v(" "),
          !_vm.$slots.default ? [_vm._v(_vm._s(_vm.label))] : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00736839", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00736839","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/core/MqlTextradio/index.vue
// module id = null
// module chunks = 